import { Select, TextField } from '@nike/eds';
import { useState } from 'react';
import { RANKING_RULE_TARGET_TYPES } from '../../constants/index';

enum PriceRelation {
  LessThan = 'lt',
  GreatThan = 'gt',
  Range = 'range',
}
const priceRangeOpts = [
  { label: 'Less than', value: PriceRelation.LessThan },
  { label: 'Great than', value: PriceRelation.GreatThan },
  { label: 'Between', value: PriceRelation.Range },
];

export default function TargetPriceForm({
  validationError,
  onActionItemsChange,
}: {
  validationError: string;
  onActionItemsChange: (
    items: RankingRuleTargetBoostItem[] | RankingRuleTargetBuryItem,
  ) => void;
}) {
  const [priceOpt, setPriceOpt] = useState(priceRangeOpts[0]);
  const [price1Value, setPrice1Value] = useState('');
  const [price2Value, setPrice2Value] = useState('');

  const handlePrice1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = event;
    const val = (target as HTMLInputElement).value;
    setPrice1Value(val);

    if (priceOpt.value === PriceRelation.Range) {
      const item = {
        type: RANKING_RULE_TARGET_TYPES.PRICE,
        multiValue: [val, price2Value],
        relation: 'range',
        label: `${price1Value} > price < ${val}`,
      };
      onActionItemsChange([item]);
    } else {
      const item = {
        type: RANKING_RULE_TARGET_TYPES.PRICE,
        value: val,
        relation: priceOpt.value === PriceRelation.LessThan ? 'lt' : 'gt',
        label:
          priceOpt.value === PriceRelation.LessThan
            ? `price < ${val}`
            : `price > ${val}`,
      };
      onActionItemsChange([item]);
    }
  };

  const handlePrice2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = event;
    const val = (target as HTMLInputElement).value;
    setPrice2Value(val);
    const item = {
      type: RANKING_RULE_TARGET_TYPES.PRICE,
      multiValue: [price1Value, val],
      relation: 'range',
      label: `${price1Value} > price < ${val}`,
    };

    onActionItemsChange([item]);
  };

  return (
    <div>
      <div className='tw-flex tw-items-end tw-justify-start tw-gap-1 tw-my-4'>
        <Select
          id='product-ranking-rule-target-select-price'
          className='tw-w-60'
          label='Product Price'
          noBorder={true}
          options={priceRangeOpts}
          value={priceOpt}
          onChange={(sv) => {
            setPriceOpt(sv as { label: string; value: PriceRelation });
          }}
          menuPosition='fixed'
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />
        <TextField
          id='product-ranking-rule-target-price-1'
          label=''
          type='number'
          value={price1Value}
          onChange={handlePrice1Change}
          hasErrors={!!validationError}
          errorMessage={validationError}
        />
        {priceOpt.value === PriceRelation.Range && (
          <TextField
            id='product-ranking-rule-target-price-2'
            label=''
            type='number'
            value={price2Value}
            onChange={handlePrice2Change}
            hasErrors={!!validationError}
            errorMessage={validationError}
          />
        )}
      </div>
    </div>
  );
}
